/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiTextInputHandlingFieldConfig} from "./UiTextInputHandlingFieldConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiTextMatchingMode} from "./UiTextMatchingMode";
import {UiFieldSubCommandHandler} from "./UiFieldConfig";
import {UiTextInputHandlingFieldSubEventSource} from "./UiTextInputHandlingFieldConfig";


export interface UiComboBoxConfig extends UiFieldConfig, UiTextInputHandlingFieldConfig {
	_type?: string;
	recordTypeId: string;
	templates: {[name: string]: UiTemplateConfig};
	idPropertyName: string;
	parentIdPropertyName?: string;
	expandedProperty?: string;
	lazyChildrenFlagProperty?: string;
	staticData?: any[];
	textMatchingMode?: UiTextMatchingMode;
	defaultDisplayTemplateName?: string;
	defaultDropDownTemplateName?: string;
	displayTemplateProperty?: string;
	dropDownTemplateProperty?: string;
	emptyTemplateName?: string;
	emptyRecord?: any;
	showDropDownButton?: boolean;
	showDropDownAfterResultsArrive?: boolean;
	highlightFirstResultEntry?: boolean;
	showHighlighting?: boolean;
	autoComplete?: boolean;
	textHighlightingEntryLimit?: number;
	allowAnyText?: boolean;
	freeTextProperty?: string;
	showClearButton?: boolean;
	matchFieldNames?: string[];
	editorTextFields?: string[];
	animate?: boolean;
	showExpanders?: boolean
}

export interface UiComboBoxSubCommandHandler extends UiFieldSubCommandHandler {
	setDropDownData(data: any[]): void;
	updateNodes(nodeList: any[]): void;
}

export interface UiComboBoxSubEventSource extends UiTextInputHandlingFieldSubEventSource {
	onLazyChildDataRequested: TeamAppsEvent<UiComboBox_LazyChildDataRequestedSubEvent>;
}

export interface UiComboBox_LazyChildDataRequestedSubEvent extends UiSubEvent {
	_type: "UiComboBox.lazyChildDataRequested";
	redundancyKey?: string;
	parentId: any
}
